/**
 * Hr api spec
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddLocationDto } from './addLocationDto';
import { AddSkillDto } from './addSkillDto';


export interface EditPositionDto { 
    /**
     * Titolo del lavoro
     */
    title?: string;
    /**
     * Azienda che offre il lavoro
     */
    company?: string;
    /**
     * Tipo di contratto (Full-time, part-time, contract, ecc.)
     */
    type?: string;
    /**
     * Data di pubblicazione dell\'offerta (ISO 8601)
     */
    date?: string;
    /**
     * Descrizione del lavoro
     */
    description?: string;
    /**
     * Localizzazione del lavoro (indirizzo, codice postale, città, stato, paese)
     */
    location?: AddLocationDto;
    /**
     * Livello di lavoro remoto disponibile
     */
    remote?: EditPositionDto.RemoteEnum;
    /**
     * Stipendio annuale
     */
    salary?: number;
    /**
     * Livello di esperienza richiesto (Senior, Junior, Mid-level)
     */
    experience?: string;
    /**
     * Responsabilità del lavoro
     */
    responsibilities?: Array<string>;
    /**
     * Qualifiche richieste
     */
    qualifications?: Array<string>;
    /**
     * Skills richieste per il lavoro
     */
    skills?: Array<AddSkillDto>;
}
export namespace EditPositionDto {
    export const RemoteEnum = {
        Full: 'full',
        Hybrid: 'hybrid',
        None: 'none'
    } as const;
    export type RemoteEnum = typeof RemoteEnum[keyof typeof RemoteEnum];
}


